import { IconSearch, IconX } from '@tabler/icons-react'
import { useEffect, useRef, useState } from 'react'

import { AstraButton, AstraIcon, AstraTextField, astraTwMerge } from '~/astra'

type Props = {
    rawNeedle: string
    setNeedle: (value: string) => void
    placeholder?: string
    'data-test'?: string
}

export const SearchText = ({ rawNeedle, setNeedle, placeholder = 'Søk', 'data-test': dataTest }: Props) => {
    const [focused, setFocused] = useState(false)
    const inputRef = useRef<HTMLInputElement>(null)
    const hasNeedle = rawNeedle.length > 0

    useEffect(() => {
        if (hasNeedle) {
            setFocused(true)
        }
    }, [hasNeedle])

    function handleBlur() {
        if (!hasNeedle) {
            setFocused(false)
        }
    }

    return (
        <div className={astraTwMerge('my-auto overflow-hidden transition-all', focused ? 'w-64' : 'w-20')} onClick={() => inputRef.current?.focus()}>
            <AstraTextField
                startIcon={<AstraIcon icon={IconSearch} />}
                data-test={dataTest || 'search-text'}
                className="m-0 w-full"
                id="search"
                placeholder={focused ? placeholder : 'Søk'}
                value={rawNeedle}
                ref={inputRef}
                onChange={e => setNeedle(e.target.value)}
                onFocus={() => setFocused(true)}
                onBlur={handleBlur}
                endIcon={hasNeedle ? <AstraButton icon={<AstraIcon icon={IconX} />} onClick={() => setNeedle('')} variant="ghost" size="small" /> : undefined}
            />
        </div>
    )
}
